module.exports = "./img/desktop_logo.ca5796e.png";